import { defineMessages } from 'react-intl';

// set of constants used for podcast components inside the src/components directory

export const LISTENED_BADGE_TIME_THRESHOLD = 30;
export const RECOMMENDED_PODCAST_DIRECTORY_ID = 'BR:38';
export const RECOMMENDED_EPISODE_DIRECTORY_ID = 'BR:52';

export const messages = defineMessages({
  podcastCount: {
    id: 'p.podcastCount',
    defaultMessage: `{count, plural,
      one {# Podcast}
      other {# Podcasts}
    }`,
  },
  episodeCount: {
    id: 'p.episodeCount',
    defaultMessage: `{count, plural,
      one {# Episode}
      other {# Episodes}
    }`,
  },
  collectedEpisodeCount: {
    id: 'p.collectedEpisodeCount',
    defaultMessage: `{count, plural,
      one {# Episode Collected}
      other {# Episodes Collected}
    }`,
  },
  metadataTexts: {
    id: 'p.metadataTexts',
    defaultMessage: '{leftText} - {rightText}',
  },
  newBadge: {
    id: 'p.newBadge',
    defaultMessage: 'New',
  },
  listenedBadge: {
    id: 'p.listenedBadge',
    defaultMessage: 'Listened',
  },
  timeLeftBadge: {
    id: 'p.timeLeftBadge',
    defaultMessage: '{timeLeft} Left',
  },
  episode: {
    id: 'p.episode',
    defaultMessage: 'Episode',
  },
  podcast: {
    id: 'p.podcast',
    defaultMessage: 'Podcast',
  },
  recommendedPodcastsForYou: {
    id: 'p.recommendedPodcastsForYou',
    defaultMessage: 'Recommended Podcasts For You',
  },
  recommendedEpisodesForYou: {
    id: 'p.recommendedEpisodesForYou',
    defaultMessage: 'Recommended Episodes For You',
  },
  recommendedForYou: {
    id: 'p.recommendedForYou',
    defaultMessage: 'Recommended For You',
  },
} as const);
